<template>
  <div class="card border-0 rounded-0">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Détails d'un bon de retour</h3>
      <router-link to="/bonretour/liste-bonRetour" class="btn btn-primary transition border-0 lh-1 fw-medium"
            style="position: absolute; right: 10px; top: 10px;">
            <i class="flaticon-left-arrow lh-1 me-1"></i>
            Retour
          </router-link>
        </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between"></div>
      <div class="row">
        <!-- Bloc des informations générales -->
        <div class="col-md-8 col-xxl-8 col-sm-12 p-0">
          <h4 class="text-black fw-bold mb-10">Informations du bon de retour</h4>
          <table class="table">
            <tbody>
              <tr>
                <td>Date de retour</td>
                <td>{{format_date( bonlivraison?.dateOperation) }} </td>
              </tr>
              <tr>
                <td>Référence Doc</td>
                <td>{{ bonlivraison?.refDoc }} </td>
              </tr>
             <tr>
                <td>Type Opération</td>
                <td>{{ bonlivraison?.typeOperation }}</td>
              </tr>
              <!-- <tr>
                <td>Motif Suivi</td>
                <td>
                  {{ bonlivraison?.motifSuivi?.libelle }}
                </td>
              </tr>-->
              <tr>
                <td>Client</td>
                <td>
                  {{ bonlivraison?.client?.nomClient}} {{ bonlivraison?.client?.prenomClient}} {{ bonlivraison?.client?.raisonSociale}}
                </td>
              </tr>
             
            </tbody>
          </table>
         
          <!-- Tableau des produits -->
          <div class="row">
            <div class="col">
              <h5 class="text-black fw-bold mt-4">Les produits du bon</h5>
            </div>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th>Produit</th>
                <th>Quantité Retour.</th>
                <th>Reste à livrer</th>
              </tr>
            </thead>
            <tbody>
            <tr v-for="(produitcondibon, index) in bonlivraison?.produitcondibons" :key="index">
              <td>{{produitcondibon.nomProd.split("|")[1]}} {{produitcondibon.nomProd.split("|")[2]}}</td>
              <td>{{ separateur(produitcondibon.qteBon) }} {{ produitcondibon.uniteMesure }}</td>
              <td>{{separateur( produitcondibon.resteAliv) }} {{ produitcondibon.uniteMesure }}</td>
            </tr>
          </tbody>
          </table>

        </div>
        <div class="col-md-4 col-xxl-4 col-sm-12 p-0">
          <h5 class="text-black fw-bold mb-10">Image du Bon</h5>
          
          <hr> <!-- Petit trait séparateur -->
          <img v-if="bonlivraison?.imageBon" :src="getUrlApiForProductFiles(bonlivraison?.imageBon)" class="d-block w-100" alt="Photo">        
        </div>
        
      </div>
    </div>
  </div>

  <!-- Bloc des images du bonlivraison avec un slider -->

</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { BonLivraison } from "@/models/BonLivraison";
import { error, getUrlApiForProductFiles, format_date, suppression,separateur } from "@/utils/utils";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "ViewBonRetour",
  setup() {
    const route = useRoute();
    const bonlivraison = ref<BonLivraison | null>(null);
    const medias = ref([]);
    const produitcondibons = ref([]);

    async function getBonLivraison(id: string) {
      try {
        const { data } = await ApiService.get(`/bonretours/${id}`);
        console.log(data);
        if (data && data.data) {
          bonlivraison.value = data.data;
          console.log("Produitcondibons :",);
          medias.value = data.data.medias; // Récupération des médias du bonlivraison
        } else {
          throw new Error("Données du bonlivraison non trouvées.");
        }
      } catch (err) {
        error(err instanceof Error ? err.message : "Erreur lors de la récupération du bonlivraison.");
      }
    }

    onMounted(() => {
      const id = route.params.id as string;
      if (id) {
        getBonLivraison(id);
      } else {
        error("ID du bonlivraison non spécifié.");
      }
    });

    return {
      bonlivraison,produitcondibons,
      medias,suppression,format_date,
      getUrlApiForProductFiles,separateur

    };
  },
});
</script>

<style scoped>
.card {
  border: none;
  /* Retire la bordure */
  margin: 0;
  /* Enlève toutes les marges */
}

.card-body {
  padding: 15px;
  /* Ajustez le padding pour vos besoins */
}

/* Enlève la marge entre les colonnes */
.row {
  margin: 0;
  /* Retire l'espacement de la rangée */
}

/* Ajout d'un petit espacement seulement avec un trait séparateur */
.table {
  border-collapse: collapse;
}

.table td {
  padding: 8px;
}

.carousel-inner img {
  max-height: 400px;
  object-fit: cover;
}
</style>
